import {
    FETCH_PAYMENTS, ADD_PAYMENT, UPDATE_PAYMENT, ASSIGN_PAYMENT,
    FETCH_FINANCIALS_GRAPH, DELETE_PAYMENTS,
    REALLOCATE_PAYMENT
} from './actionTypes';


export const fetchPayments = (params={paymentIds:[], tenantIds:[], propertyIds:[], unitIds:[],
    startDate: "", endDate:"", minAmount:0, maxAmount:0, status:[], paymentSources: [],
    unassigned: false, searchText: "", offset:"", source:"PAYMENTS_TAB"
}) => {
    return ({
        type: FETCH_PAYMENTS,
        payload: {
            ...params
        }
        });
}

export const fetchFinancialsGraph = (params={propertyIds:[], startDate:"", endDate:""}) => {
    return ({
        type: FETCH_FINANCIALS_GRAPH,
        payload: { ...params }
    })
}


export const addPayment = ({tenantId, amount, description, paymentType,
    creditNote, status, paymentDate, fileUpload, bankTransactionId, sendReceipt}) => ({
    type: ADD_PAYMENT,
    payload: {
        description,
        tenantId, amount, paymentType, bankTransactionId,
        creditNote, status, paymentDate, fileUpload,
        sendReceipt: Boolean(sendReceipt)
    }
});

export const updatePayment = ({paymentId, tenantId, amount, description, paymentType,
    creditNote, status, paymentDate, fileUpload, bankTransactionId, updateFile, sendReceipt}) => ({
    type: UPDATE_PAYMENT,
    payload: {
        status: status.toLowerCase(),
        paymentId,
        tenantId, amount, paymentType,
        creditNote,
        description,
        paymentDate,
        fileUpload,
        bankTransactionId,
        updateFile,
        sendReceipt: Boolean(sendReceipt)
    }
});

export const deletePayments = (paymentIds) => ({
    type: DELETE_PAYMENTS,
    payload: {
        paymentIds
    }
});

export const assignPayment = (tenantId ,paymentId, unassignedFilter) => ({
    type: ASSIGN_PAYMENT,
    payload: {
        tenantId,
        paymentId,
        unassignedFilter
    }
});

export const reallocatePayment = (tenantId ,paymentId) => ({
    type: REALLOCATE_PAYMENT,
    payload: {
        tenantId,
        paymentId
    }
});